import React from "react"
import _ from "lodash"
import { useLazyGetInstitutionClassesQuery } from "../../Redux/actions/classSetup.action"

/**
 * Normalises "which classes exist" for an institution into one shape. Used by
 * student sign-up, where a student picks their school and then their class.
 *
 * @param {number|string|null} institution_ref
 * @returns {{classes: Array, isLoading: boolean}}
 */
export default function useLectureTaxonomy(institution_ref) {
    const [getClassesAction, getClassesState] =
        useLazyGetInstitutionClassesQuery()

    React.useEffect(() => {
        if (institution_ref) {
            getClassesAction({ institution_ref })
        }
    }, [getClassesAction, institution_ref])

    const classes = React.useMemo(() => {
        if (!institution_ref) return []
        const list = _.get(getClassesState, "currentData.list", [])
        return (Array.isArray(list) ? list : []).map((item) => ({
            class_id: String(item.class_id || item._id || item.id),
            class_name: item.class_name,
            meta_data: item.meta_data
        }))
    }, [getClassesState, institution_ref])

    return {
        classes,
        isLoading: Boolean(institution_ref) && getClassesState.isFetching
    }
}
